import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import CategoryScreen from '../../../components/categoryScreen';
import CategoryScreenBG from '../../../images/ComponentImages/categoryScreenBackground.png';
import RoundScreen from '../../../components/roundScreen';

export default function Page09({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<CategoryScreen BGImage={CategoryScreenBG} titles={['Day 2', 'Chest & Biceps']} />
			<RoundScreen
				title='Exercise 01 Bench Press'
				rounds={[
					[
						{
							header: 'Exercise',
							value: 'Incline Bench Press',
						},
						{
							header: '# of sets',
							value: '1',
						},
						{
							header: 'REPS / Weight',
							value: '10 Light',
						},
						{
							header: 'MINDSET/ FOCUSES INSTRUCTIONS',
							value: 'Warm up, Focus on the SQUEEZE, “Blood Flowing”',
						},
					],
					[
						{
							header: 'Exercise',
							value: 'Incline Bench Press',
						},
						{
							header: '# of sets',
							value: '2 - 3',
						},
						{
							header: 'REPS / Weight',
							value: 'Mild - Heavy',
						},
						{
							header: 'MINDSET/ FOCUSES INSTRUCTIONS',
							value: 'Working Set, Strong SQUEEZE, Control the Negative',
						},
					],
					[
						{
							header: 'Exercise',
							value: 'Incline Bench Press',
						},
						{
							header: '# of sets',
							value: '4',
						},
						{
							header: 'REPS / Weight',
							value: 'Heavy',
						},
						{
							header: 'MINDSET/ FOCUSES INSTRUCTIONS',
							value: 'Full On Set Till Failure',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
